import { clearSupabaseCookies } from "@/lib/utils/auth/clear-cookies";
import { logger } from "@/lib/logger";
import type { SupabaseBrowserClient } from "./types";

interface CreateMagicLinkHandlerArgs {
  supabase: SupabaseBrowserClient;
  email: string;
  setIsLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  setSuccess: (success: string | null) => void;
}

export function createMagicLinkHandler(args: CreateMagicLinkHandlerArgs) {
  const { supabase, email, setIsLoading, setError, setSuccess } = args;

  return async () => {
    if (!email) {
      setError("Please enter your email address");
      return;
    }

    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
      // Clear existing cookies before sending magic link
      const clearResult = clearSupabaseCookies();
      logger.info("Cleared cookies before magic link:", { clearResult });

      const currentOrigin = window.location.origin;
      const callbackUrl = `${currentOrigin}/auth/callback`;

      logger.info("🔗 Requesting magic link with redirect:", {
        currentOrigin,
        callbackUrl,
        isLocalhost: currentOrigin.includes("localhost") || currentOrigin.includes("127.0.0.1"),
      });

      // Use standard Supabase magic link with callback redirect
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: callbackUrl,
        },
      });

      if (error) {
        setError(error.message);
        return;
      }

      setSuccess("Check your email for the magic link!");
    } catch (err) {
      logger.error("Magic link error", err);
      setError("An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  };
}
